export enum EnumStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum EnumSort {
  DESC = 'DESC',
  ASC = 'ASC'
}
